"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildModel = (model) => {
    model = model.replace(/_/g, " ");
    model = model.replace(RegExp(" TD$", "i"), "");
    if (model === "Build")
        return "";
    return model;
};



//////////////////
// WEBPACK FOOTER
// ./~/device-detector-js/dist/utils/model.js
// module id = 1418
// module chunks = 13 14